export var BannerNotificationContentType;
(function (BannerNotificationContentType) {
    BannerNotificationContentType["SURVEY_ID"] = "survey_id";
    BannerNotificationContentType["LINK"] = "link";
})(BannerNotificationContentType || (BannerNotificationContentType = {}));
//# sourceMappingURL=BannerNotificationContentType.js.map